import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { Notice, NoticeList } from '@/assets/data/noticeList';
import Card, { CardTitle } from '@/components/Card';
import TextComponent from '@/components/TextComponent';
import ButtonComponent from '@/components/ButtonComponent';
import theme from '@/styles/theme';

const NoticeDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const notice: Notice = NoticeList.filter(item => item.id === Number(id))[0];

  const onClickLink = () => {
    window.open(notice.buttonLink, '_blank');
  };

  return (
    <Wrapper>
      <CardTitle>공지사항</CardTitle>
      <Card>
        <CardTop>
          <Tag type={notice.type}>
            {notice.type === 'update' ? '업데이트' : '공지사항'}
          </Tag>
          <NoticeTitle>{notice.title}</NoticeTitle>
        </CardTop>
        <CardContent>
          <NoticeInfo>
            <NoticeInfoText>작성일 : {notice.createdAt}</NoticeInfoText>
            <NoticeInfoText>작성자 : {notice.author}</NoticeInfoText>
          </NoticeInfo>
          <NoticeImg
            src={require(`../../assets/images/notice/${notice.content}`)}
            alt={'noticeContent'}
          />
          {notice.buttonLink && (
            <ButtonWrapper>
              <ButtonComponent
                bgColor={theme.DF_COLOR.WHITE}
                borderColor={theme.DF_COLOR.GRAY600}
                textColor={theme.DF_COLOR.GRAY600}
                text={notice.buttonText}
                fontSize={24}
                disabled={false}
                onClick={onClickLink}
                padding={'1rem'}
                style={{ width: 470 }}
              />
            </ButtonWrapper>
          )}
        </CardContent>
      </Card>
    </Wrapper>
  );
};

export default NoticeDetailPage;

const Wrapper = styled.div`
  width: 100%;
`;

const CardTop = styled.div`
  display: flex;
  padding: 30px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
`;

const NoticeTitle = styled(TextComponent)`
  font-size: 20px;
  font-weight: 700;
`;

const Tag = styled.div<{ type: string }>`
  padding: 6px 8px 5px;
  border-radius: 8px;
  font-weight: 700;
  margin-right: 15px;
  font-size: 13px;
  border: 1px solid
    ${({ type, theme }) =>
      type === 'update' ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.BLUE500};
  color: ${({ type, theme }) =>
    type === 'update' ? theme.DF_COLOR.PRIMARY500 : theme.DF_COLOR.BLUE500};
`;

const CardContent = styled.div`
  padding: 30px;
`;

const NoticeInfo = styled.div`
  text-align: end;

  > * {
    &:first-child {
      margin-bottom: 11px;
    }
  }
`;

const NoticeInfoText = styled(TextComponent)`
  font-size: 16px;
`;

const NoticeImg = styled.img`
  max-width: 1000px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;
